import { formatPropertyAddress } from '@addava/skills/presentation';
import { formatPropertyStreet } from '@addava/skills/notifications';

/** A user label never changes the address used for lookup or source evidence. */
export function propertyDisplayName(
  property: { address: string; nickname?: string | null },
  streetOnly = false,
) {
  return (
    property.nickname?.trim() ||
    (streetOnly ? formatPropertyStreet(property.address) : formatPropertyAddress(property.address))
  );
}
